/* ================================================================
   TITANIUM NUTRITION — titanium.js v1.1
   ================================================================ */
(function () {
  'use strict';

  /* Sticky header */
  const header = document.querySelector('.ti-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('is-scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* Mobile nav — Escape key only; open/close handled inline in ti-header.liquid */
  const navToggle = document.querySelector('[data-ti-nav-toggle]');
  const mobileNav = document.getElementById('ti-mobile-nav');
  if (navToggle && mobileNav) {
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        mobileNav.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', false);
        document.body.style.overflow = '';
      }
    });
  }

  /* Marquee pause */
  document.querySelectorAll('.ti-marq').forEach(m => {
    const t = m.querySelector('.ti-marq-track');
    m.addEventListener('mouseenter', () => t?.style.setProperty('animation-play-state', 'paused'));
    m.addEventListener('mouseleave', () => t?.style.setProperty('animation-play-state', 'running'));
  });

  /* Scroll reveal */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('[data-ti-reveal]').forEach(el => io.observe(el));
  }

  /* ---- Cart API helpers ---- */
  const fmt = (p, currency) => new Intl.NumberFormat('it-IT', { style: 'currency', currency: currency || 'EUR' }).format(p / 100);

  async function fetchCart() {
    const r = await fetch('/cart.js');
    return r.json();
  }
  async function cartAdd(id, qty = 1) {
    const r = await fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity: qty })
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Errore aggiunta al carrello');
    }
    return r.json();
  }
  async function cartChange(key, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Quantità non disponibile');
    }
    return r.json();
  }
  async function updateCartCount() {
    try {
      const cart = await fetchCart();
      _lastCart = cart;
      document.querySelectorAll('.ti-cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });
      return cart;
    } catch (_) {}
  }

  /* ---- Omaggio a soglia (gift with purchase) ----
     Config globale in window.tiGift (iniettata da layout/theme.liquid).
     La soglia si calcola sul carrello escluse le righe con properties._gift. */
  let _lastCart = null;
  let giftOpen = false;
  let giftPromptActive = false; // promemoria pre-checkout attivo nel drawer
  function giftEnabled() {
    return !!(window.tiGift && window.tiGift.enabled && (window.tiGift.products || []).filter(Boolean).length);
  }
  function isGiftLine(item) {
    return !!(item.properties && item.properties._gift);
  }
  function giftEligibleTotal(cart) {
    return cart.items.reduce((sum, i) => isGiftLine(i) ? sum : sum + i.final_line_price, 0);
  }
  function giftNeedsRemoval(cart) {
    return giftEnabled()
      && giftEligibleTotal(cart) < window.tiGift.threshold
      && cart.items.some(isGiftLine);
  }
  async function removeGiftLines(cart) {
    for (const g of cart.items.filter(isGiftLine)) {
      try { await cartChange(g.key, 0); } catch (_) {}
    }
  }
  async function addGift(variantId) {
    const cart = await fetchCart();
    await removeGiftLines(cart);
    const r = await fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _gift: 'true' } }] })
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Omaggio non disponibile');
    }
  }
  function showGiftError(msg) {
    document.querySelectorAll('[data-ti-gift-error]').forEach(el => {
      el.textContent = msg;
      setTimeout(() => { el.textContent = ''; }, 6000);
    });
  }

  /* Sync per la pagina carrello: chiamata da sections/ti-cart-main.liquid dopo ogni update */
  window.tiGiftSync = function (cart) {
    _lastCart = cart;
    if (!giftEnabled()) return;
    const unlocked = giftEligibleTotal(cart) >= window.tiGift.threshold;
    const hasGift = cart.items.some(isGiftLine);
    if (!unlocked && hasGift) {
      removeGiftLines(cart).then(() => window.location.reload());
      return;
    }
    const box = document.querySelector('[data-ti-gift-box]');
    if (box && ((box.dataset.unlocked === 'true') !== unlocked || (box.dataset.hasGift === 'true') !== hasGift)) {
      window.location.reload();
    }
  };

  /* Delegation: sopravvive ai re-render del theme editor e serve pagina carrello + drawer */
  document.addEventListener('click', async e => {
    // Apri/chiudi il selettore nel drawer
    const toggleBtn = e.target.closest('[data-ti-gift-toggle]');
    if (toggleBtn) {
      giftOpen = !giftOpen;
      if (_lastCart) renderDrawerGift(_lastCart);
      return;
    }
    // Chiudi il prompt promemoria checkout
    if (e.target.closest('[data-ti-gift-prompt-close]')) {
      giftPromptActive = false;
      if (_lastCart && document.getElementById('ti-drawer-gift')) renderDrawerGift(_lastCart);
      document.querySelector('[data-ti-gift-box] [data-ti-gift-prompt]')?.remove();
      return;
    }

    const addBtn = e.target.closest('[data-ti-gift-add]');
    const removeBtn = e.target.closest('[data-ti-gift-remove]');
    const btn = addBtn || removeBtn;
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    const onCartPage = !!document.getElementById('ti-cart-form');
    try {
      if (addBtn) await addGift(parseInt(addBtn.dataset.tiGiftAdd));
      else await removeGiftLines(await fetchCart());
      if (addBtn) { giftOpen = false; giftPromptActive = false; } // omaggio scelto: richiudi selettore e promemoria
      if (onCartPage) { window.location.reload(); return; }
      updateCartCount();
      await refreshDrawer();
    } catch (err) {
      btn.disabled = false;
      updateCartCount();
      if (!onCartPage) await refreshDrawer();
      showGiftError(err.message || 'Errore, riprova');
    }
  });

  /* Promemoria checkout: se l'omaggio è sbloccato ma non scelto, avvisa una sola volta (mai bloccante) */
  document.addEventListener('click', e => {
    const ck = e.target.closest('#ti-cart-panel a[href="/checkout"], #ti-cart-form button[name="checkout"]');
    if (!ck || !giftEnabled() || !_lastCart) return;
    if (sessionStorage.getItem('ti-gift-checkout-ok')) return;
    if (giftEligibleTotal(_lastCart) < window.tiGift.threshold) return;
    if (_lastCart.items.some(isGiftLine)) return;
    e.preventDefault();
    sessionStorage.setItem('ti-gift-checkout-ok', '1');
    showGiftCheckoutPrompt(!!ck.closest('#ti-cart-panel'));
  });

  function showGiftCheckoutPrompt(fromDrawer) {
    if (fromDrawer) {
      // Nel drawer il prompt sostituisce il toggle (renderDrawerGift), niente banner impilati
      const host = document.getElementById('ti-drawer-gift');
      if (!host || !_lastCart) { window.location.href = '/checkout'; return; } // fail open: mai bloccare il checkout
      giftPromptActive = true;
      renderDrawerGift(_lastCart);
      return;
    }
    const host = document.querySelector('[data-ti-gift-box]');
    if (!host) { window.location.href = '/checkout'; return; } // fail open: mai bloccare il checkout
    host.scrollIntoView({ behavior: 'smooth', block: 'center' });
    host.querySelector('[data-ti-gift-prompt]')?.remove();
    const div = document.createElement('div');
    div.className = 'ti-gift-ck-prompt';
    div.setAttribute('data-ti-gift-prompt', '');
    div.innerHTML = `
      <span>🎁 Hai diritto a un omaggio!</span>
      <div class="ti-gift-ck-actions">
        <button type="button" class="ti-btn ti-btn-primary ti-btn-sm" data-ti-gift-prompt-close>Scegli l'omaggio</button>
        <a href="/checkout" class="ti-btn ti-btn-ghost ti-btn-sm">Continua senza →</a>
      </div>`;
    host.prepend(div);
  }

  /* Safety net al caricamento: se il carrello è sceso sotto soglia (es. da un'altra pagina)
     l'omaggio va rimosso ovunque ci si trovi */
  updateCartCount().then(cart => {
    if (cart && giftNeedsRemoval(cart)) {
      removeGiftLines(cart).then(() => {
        document.getElementById('ti-cart-form') ? window.location.reload() : updateCartCount();
      });
    }
  });

  /* ---- Cart Drawer ---- */
  let drawerReady = false;
  function buildDrawer() {
    if (drawerReady) return;
    drawerReady = true;
    const el = document.createElement('div');
    el.id = 'ti-cart-drawer';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = `
      <div id="ti-cart-overlay"></div>
      <div id="ti-cart-panel" role="dialog" aria-modal="true" aria-label="Carrello">
        <div class="ti-drawer-head">
          <span class="ti-eye" style="margin:0;">Il tuo carrello</span>
          <button id="ti-cart-close" class="ti-btn-icon" aria-label="Chiudi">
            <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div id="ti-drawer-incentives"></div>
        <div id="ti-drawer-body"><div id="ti-drawer-items"></div></div>
        <div id="ti-drawer-foot">
          <div id="ti-drawer-gift"></div>
          <div class="ti-drawer-total"><span>Totale</span><span id="ti-drawer-price">—</span></div>
          <a href="/checkout" class="ti-btn ti-btn-primary" style="width:100%;justify-content:center;">Checkout →</a>
          <div class="ti-drawer-footlinks"><a href="/cart">Vedi carrello</a><span>Pagamento sicuro · SSL</span></div>
        </div>
      </div>`;
    document.body.appendChild(el);
    document.getElementById('ti-cart-overlay').addEventListener('click', closeDrawer);
    document.getElementById('ti-cart-close').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
  }

  function openDrawer() {
    buildDrawer();
    refreshDrawer();
    const d = document.getElementById('ti-cart-drawer');
    d.setAttribute('aria-hidden', 'false');
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    const d = document.getElementById('ti-cart-drawer');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  async function refreshDrawer() {
    let cart = await fetchCart();
    // Carrello sceso sotto soglia: togli l'omaggio prima di renderizzare
    if (giftNeedsRemoval(cart)) {
      await removeGiftLines(cart);
      cart = await fetchCart();
    }
    _lastCart = cart;
    const items = document.getElementById('ti-drawer-items');
    const priceEl = document.getElementById('ti-drawer-price');
    if (!items) return;
    updateCartCount();

    if (cart.item_count === 0) {
      items.innerHTML = `<div class="ti-drawer-empty"><span class="ti-eye">Carrello vuoto</span><p>Aggiungi qualcosa per iniziare.</p><a href="/collections/all" class="ti-btn ti-btn-primary">Scopri i prodotti</a></div>`;
    } else {
      items.innerHTML = cart.items.map(item => {
        // Riga omaggio: quantità fissa, prezzo GRATIS, niente stepper
        if (isGiftLine(item)) {
          return `
        <div class="ti-drawer-line" data-key="${item.key}">
          <a href="${item.url}" class="ti-drawer-line-img" tabindex="-1">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" width="80" height="80" loading="lazy">` : ''}
          </a>
          <div class="ti-drawer-line-body">
            <a href="${item.url}" class="ti-drawer-line-name">${item.product_title}</a>
            <span class="ti-gift-line-badge">🎁 Omaggio</span>
            <div class="ti-drawer-line-foot">
              <span class="ti-gift-line-qty">×1</span>
              <span class="ti-price-now" style="font-size:16px;${item.final_line_price === 0 ? 'color:var(--ti-ok);' : ''}">${item.final_line_price === 0 ? 'GRATIS' : fmt(item.final_line_price, cart.currency)}</span>
            </div>
          </div>
          <button class="ti-drawer-remove" data-key="${item.key}" aria-label="Rimuovi">
            <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>`;
        }
        const s = (window.tiStock || {})[item.variant_id];
        const max = (s && s.tracked) ? s.qty : 99;
        return `
        <div class="ti-drawer-line" data-key="${item.key}">
          <a href="${item.url}" class="ti-drawer-line-img" tabindex="-1">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" width="80" height="80" loading="lazy">` : ''}
          </a>
          <div class="ti-drawer-line-body">
            <a href="${item.url}" class="ti-drawer-line-name">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="ti-cart-line-variant">${item.variant_title}</span>` : ''}
            ${(s && s.tracked && s.qty > 0 && s.qty < (window.tiStockThreshold || 10)) ? `<span class="${s.qty <= 5 ? 'ti-stock-badge' : 'ti-stock-info'}">${s.qty <= 5 ? `Solo ${s.qty} disponibili` : `${s.qty} disponibili`}</span>` : ''}
            <div class="ti-drawer-line-foot">
              <div class="ti-stepper ti-stepper--sm">
                <button type="button" data-dqty="-1" data-key="${item.key}">−</button>
                <input type="number" value="${item.quantity}" min="0" max="${max}" data-max="${max}" data-key="${item.key}" aria-label="Quantità">
                <button type="button" data-dqty="+1" data-key="${item.key}">+</button>
              </div>
              <span class="ti-price-now" style="font-size:16px;">${fmt(item.final_line_price, cart.currency)}</span>
            </div>
          </div>
          <button class="ti-drawer-remove" data-key="${item.key}" aria-label="Rimuovi">
            <svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>`;
      }).join('');

      const _dTimers = {};
      const _dOriginals = {};
      function debouncedChange(key, inp) {
        clearTimeout(_dTimers[key]);
        _dTimers[key] = setTimeout(async () => {
          delete _dTimers[key];
          const finalQ = parseInt(inp.value) || 0;
          const origQ = _dOriginals[key];
          delete _dOriginals[key];
          if (finalQ === origQ) return;
          try {
            await cartChange(key, finalQ);
            refreshDrawer();
          } catch (err) {
            // Re-fetch per lo stato reale dopo il 422
            const freshCart = await fetch('/cart.js').then(r => r.json()).catch(() => null);
            const actualQty = freshCart?.items?.find(i => i.key === key)?.quantity ?? origQ;
            inp.value = actualQty;
            const curMax = parseInt(inp.dataset.max) || 99;
            if (actualQty < curMax) {
              inp.dataset.max = actualQty;
              // Aggiorna tiStock così i click futuri restano cappati
              if (freshCart) {
                const ci = freshCart.items.find(i => i.key === key);
                if (ci && window.tiStock?.[ci.variant_id]) window.tiStock[ci.variant_id].qty = actualQty;
              }
            }
            showDrawerError(items, key, err.message);
          }
        }, 250);
      }
      items.querySelectorAll('[data-dqty]').forEach(btn => {
        btn.addEventListener('click', () => {
          const key = btn.dataset.key;
          const inp = items.querySelector(`input[data-key="${key}"]`);
          if (!inp) return;
          if (!_dTimers[key]) _dOriginals[key] = parseInt(inp.value) || 0;
          const max = parseInt(inp.dataset.max) || 99;
          let q = parseInt(inp.value) || 0;
          q = btn.dataset.dqty === '-1' ? Math.max(0, q - 1) : Math.min(max, q + 1);
          inp.value = q;
          debouncedChange(key, inp);
        });
      });
      // Input manuale: valida e invia al blur/enter
      items.querySelectorAll('input[data-key]').forEach(inp => {
        inp.addEventListener('change', () => {
          const key = inp.dataset.key;
          const max = parseInt(inp.dataset.max) || 99;
          let q = parseInt(inp.value);
          if (isNaN(q) || q < 0) q = 0;
          if (q < 0) q = 0; // solo sanifica — il server è l'autorità sul massimo
          inp.value = q;
          // Se non c'è un debounce attivo cattura il valore pre-edit come origine
          if (!_dTimers[key]) _dOriginals[key] = parseInt(inp.defaultValue) || 0;
          debouncedChange(key, inp);
        });
      });
      items.querySelectorAll('.ti-drawer-remove').forEach(btn => {
        btn.addEventListener('click', async () => {
          try {
            await cartChange(btn.dataset.key, 0);
            refreshDrawer();
          } catch (_) {}
        });
      });
    }

    if (priceEl) priceEl.textContent = fmt(cart.total_price, cart.currency);

    renderGoalbar(document.getElementById('ti-drawer-incentives'), cart);
    renderDrawerGift(cart);
  }

  /* ---- Goalbar: barra incentivi unificata (spedizione gratuita + omaggio) ----
     Un'unica progress bar con traguardi multipli; base = totale carrello
     escluse le righe omaggio (stessa base della logica gift, sconti inclusi).
     Il markup deve restare identico a quello server-side in
     sections/ti-cart-main.liquid (first paint pagina carrello). */
  function goalMilestones() {
    const ms = [];
    if (window.tiShip && window.tiShip.showBar && window.tiShip.threshold > 0) {
      ms.push({ threshold: window.tiShip.threshold, icon: '🚚', name: 'Spedizione', next: 'per la spedizione gratuita', done: 'Hai la spedizione gratuita!' });
    }
    if (giftEnabled() && window.tiGift.threshold > 0) {
      ms.push({ threshold: window.tiGift.threshold, icon: '🎁', name: 'Omaggio', next: 'per il tuo omaggio', done: 'Omaggio sbloccato!' });
    }
    return ms.sort((a, b) => a.threshold - b.threshold);
  }

  function renderGoalbar(container, cart) {
    if (!container) return;
    const ms = goalMilestones();
    if (!ms.length || !cart || cart.item_count === 0) { container.innerHTML = ''; return; }
    const basis = giftEligibleTotal(cart);
    const max = ms[ms.length - 1].threshold;
    const nextGoal = ms.find(m => basis < m.threshold);
    const pct = Math.min(100, basis / max * 100);
    const fmtShort = v => fmt(v, cart.currency).replace(/,00(?=\s|$)/, '');
    const msg = nextGoal
      ? `Aggiungi <b>${fmt(nextGoal.threshold - basis, cart.currency)}</b> ${nextGoal.next}`
      : `🎉 ${ms.length > 1 ? 'Spedizione gratuita + omaggio sbloccati!' : ms[0].done}`;
    container.innerHTML = `
      <div class="ti-goalbar${container.closest('.ti-cart-summary') ? ' ti-goalbar--flat' : ''}${nextGoal ? '' : ' ti-goalbar--done'}">
        <div class="ti-goalbar-msg">${msg}</div>
        <div class="ti-goalbar-track">
          <div class="ti-goalbar-fill" style="width:${pct}%;"></div>
          ${ms.map(m => `<div class="ti-goalbar-dot${basis >= m.threshold ? ' is-hit' : ''}" style="left:${Math.min(100, m.threshold / max * 100)}%;"></div>`).join('')}
        </div>
        <div class="ti-goalbar-legend">
          ${ms.map(m => `<span${basis >= m.threshold ? ' class="is-hit"' : ''}>${basis >= m.threshold ? '✓ ' : ''}${m.icon} ${fmtShort(m.threshold)} · ${m.name}</span>`).join('')}
        </div>
      </div>`;
  }
  window.tiRenderGoalbar = renderGoalbar;

  function renderDrawerGift(cart) {
    const box = document.getElementById('ti-drawer-gift');
    if (!box) return;
    if (!giftEnabled() || cart.item_count === 0) { box.innerHTML = ''; return; }
    const g = window.tiGift;
    const eligible = giftEligibleTotal(cart);
    const giftLine = cart.items.find(isGiftLine);

    if (eligible < g.threshold) {
      // Sotto soglia: il messaggio di progresso vive nella goalbar in cima al drawer
      giftPromptActive = false;
      box.innerHTML = '';
      return;
    }

    // Auto-apertura solo la prima volta che la soglia risulta superata senza omaggio scelto
    if (!giftLine && !sessionStorage.getItem('ti-gift-auto-opened')) {
      sessionStorage.setItem('ti-gift-auto-opened', '1');
      giftOpen = true;
    }

    let html;
    if (giftPromptActive && !giftLine) {
      // Promemoria pre-checkout: sostituisce il toggle (niente banner impilati)
      giftOpen = true;
      html = `
      <div class="ti-gift-ck-prompt" data-ti-gift-prompt>
        <span>🎁 Hai diritto a un omaggio!</span>
        <div class="ti-gift-ck-actions">
          <button type="button" class="ti-btn ti-btn-primary ti-btn-sm" data-ti-gift-prompt-close>Scegli l'omaggio</button>
          <a href="/checkout" class="ti-btn ti-btn-ghost ti-btn-sm">Continua senza →</a>
        </div>
      </div>`;
    } else {
      const toggleLabel = giftLine
        ? `🎁 Omaggio: <b>✓ ${giftLine.product_title}</b>`
        : `🎁 Omaggio sbloccato — scegli`;
      html = `
      <button type="button" class="ti-drawer-gift-toggle" data-ti-gift-toggle aria-expanded="${giftOpen}">
        <span>${toggleLabel}</span><span class="ti-drawer-gift-arrow">${giftOpen ? '▴' : '▾'}</span>
      </button>`;
    }

    if (giftOpen) {
      const cards = g.products.filter(Boolean).map(p => {
        const selected = giftLine && giftLine.variant_id === p.variantId;
        return `
        <div class="ti-drawer-gift-card${selected ? ' is-selected' : ''}">
          ${p.image ? `<img src="${p.image}" alt="${p.title}" width="44" height="44" loading="lazy">` : ''}
          <div class="ti-drawer-gift-card-body">
            <span class="ti-drawer-gift-name">${p.title}</span>
            <span class="ti-drawer-gift-price"><s>${fmt(p.price, cart.currency)}</s> <b>GRATIS</b></span>
          </div>
          ${selected
            ? `<button type="button" class="ti-btn ti-btn-ghost ti-btn-sm" data-ti-gift-remove>✓</button>`
            : `<button type="button" class="ti-btn ti-btn-primary ti-btn-sm" data-ti-gift-add="${p.variantId}">${giftLine ? 'Scambia' : 'Aggiungi'}</button>`}
        </div>`;
      }).join('');
      html += `<div class="ti-drawer-gift-cards">${cards}</div>`;
    }

    box.innerHTML = html + `<div data-ti-gift-error></div>`;
  }

  function showDrawerError(container, key, msg) {
    const line = container.querySelector(`.ti-drawer-line[data-key="${key}"]`);
    if (!line) return;
    let errEl = line.querySelector('.ti-stock-err');
    if (!errEl) {
      errEl = document.createElement('span');
      errEl.className = 'ti-stock-err';
      errEl.style.cssText = 'display:block;font-family:var(--font-mono);font-size:10px;color:var(--ti-err);letter-spacing:1px;text-transform:uppercase;margin-top:6px;';
      line.querySelector('.ti-drawer-line-body')?.appendChild(errEl);
    }
    errEl.textContent = msg;
    setTimeout(() => errEl?.remove(), 4000);
  }

  /* Open drawer on header cart click */
  document.querySelectorAll('.ti-header-tools a[href="/cart"]').forEach(link => {
    link.addEventListener('click', e => { e.preventDefault(); openDrawer(); });
  });

  /* Quick add buttons */
  document.querySelectorAll('[data-ti-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const id = btn.dataset.tiAddToCart;
      if (!id) return;
      const orig = btn.textContent;
      btn.disabled = true; btn.textContent = '...';
      try {
        await cartAdd(id);
        // Aggiorna mappa stock locale con i dati esposti dal bottone
        if (btn.dataset.tracked === 'true') {
          window.tiStock = window.tiStock || {};
          window.tiStock[id] = { qty: parseInt(btn.dataset.stock) || 0, tracked: true };
        }
        btn.textContent = '✓ Aggiunto';
        updateCartCount();
        openDrawer();
        setTimeout(() => { btn.disabled = false; btn.textContent = orig; }, 2000);
      } catch (err) {
        btn.disabled = false;
        btn.textContent = err.message || orig;
        setTimeout(() => { btn.textContent = orig; }, 3500);
      }
    });
  });

  /* ---- Predictive Search ---- */
  const searchInput = document.querySelector('[data-ti-search-input]');
  if (searchInput) {
    let timer;
    const resultsCont = document.getElementById('ti-search-results');
    searchInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = searchInput.value.trim();
      if (q.length < 2) { if (resultsCont) resultsCont.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        try {
          const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
          const data = await r.json();
          const products = data.resources?.results?.products || [];
          if (!resultsCont) return;
          if (!products.length) { resultsCont.innerHTML = `<p class="ti-search-no-results">Nessun risultato per "${q}"</p>`; return; }
          resultsCont.innerHTML = products.map(p =>
            `<a href="${p.url}" class="ti-search-result">
              ${p.featured_image?.url ? `<img src="${p.featured_image.url}" alt="${p.title}" width="48" height="48">` : '<div class="ti-search-result-img-placeholder"></div>'}
              <div class="ti-search-result-body">
                <span class="ti-search-result-type">${p.product_type || ''}</span>
                <span class="ti-search-result-title">${p.title}</span>
              </div>
              <span class="ti-search-result-price">${p.price_min ? fmt(Math.round(parseFloat(p.price_min) * 100)) : ''}</span>
            </a>`).join('') +
            `<a href="/search?type=product&q=${encodeURIComponent(q)}" class="ti-search-all">Vedi tutti →</a>`;
        } catch (_) {}
      }, 280);
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && resultsCont) resultsCont.innerHTML = ''; });
    document.addEventListener('click', e => { if (!e.target.closest('[data-ti-search-wrap]') && resultsCont) resultsCont.innerHTML = ''; });
  }

  /* ---- Wishlist (localStorage UI only) ---- */
  document.querySelectorAll('.ti-card-wish').forEach(btn => {
    const pid = btn.dataset.productId;
    if (pid && localStorage.getItem('ti-wish-' + pid)) btn.style.color = btn.style.borderColor = '#FF4D6D';
    btn.addEventListener('click', e => {
      e.preventDefault();
      const active = btn.classList.toggle('is-active');
      btn.style.color = btn.style.borderColor = active ? '#FF4D6D' : '';
      if (pid) active ? localStorage.setItem('ti-wish-' + pid, '1') : localStorage.removeItem('ti-wish-' + pid);
    });
  });

  /* ---- Inject CSS ---- */
  const s = document.createElement('style');
  s.textContent = `
    #ti-cart-drawer{display:none}
    #ti-cart-drawer.is-open{display:block}
    #ti-cart-overlay{position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:400;backdrop-filter:blur(4px)}
    #ti-cart-panel{position:fixed;right:0;top:0;bottom:0;width:min(420px,100vw);background:var(--ti-black);border-left:1px solid var(--ti-border);z-index:401;display:flex;flex-direction:column;transform:translateX(100%);transition:transform var(--dur-med) var(--ease-out)}
    #ti-cart-drawer.is-open #ti-cart-panel{transform:translateX(0)}
    .ti-drawer-head{display:flex;align-items:center;justify-content:space-between;padding:var(--s-5);border-bottom:1px solid var(--ti-border)}
    #ti-drawer-body{flex:1;overflow-y:auto;padding:var(--s-4) var(--s-5)}
    #ti-drawer-foot{padding:var(--s-4) var(--s-5) var(--s-6);border-top:1px solid var(--ti-border);display:flex;flex-direction:column;gap:var(--s-2)}
    .ti-drawer-line{display:grid;grid-template-columns:80px 1fr auto;gap:var(--s-3);align-items:start;padding:var(--s-3) 0;border-bottom:1px solid var(--ti-border)}
    .ti-drawer-line:last-child{border-bottom:none}
    .ti-drawer-line-img{display:block;width:80px;height:80px;background:var(--ti-card);border:1px solid var(--ti-border);overflow:hidden}
    .ti-drawer-line-img img{width:100%;height:100%;object-fit:contain;padding:6px}
    .ti-drawer-line-body{display:flex;flex-direction:column;gap:6px}
    .ti-drawer-line-name{font-family:var(--font-condensed);font-weight:800;text-transform:uppercase;font-size:14px;color:var(--ti-text);text-decoration:none;line-height:1.1}
    .ti-drawer-line-name:hover{color:var(--ti-yellow)}
    .ti-drawer-line-foot{display:flex;align-items:center;justify-content:space-between;gap:var(--s-3);margin-top:var(--s-2)}
    .ti-drawer-remove{background:transparent;border:none;cursor:pointer;color:var(--ti-muted);padding:4px;transition:color var(--dur-fast)}
    .ti-drawer-remove:hover{color:var(--ti-err)}
    .ti-drawer-total{display:flex;justify-content:space-between;align-items:baseline;font-family:var(--font-display);font-size:26px;text-transform:uppercase;color:var(--ti-text);padding:var(--s-3) 0}
    .ti-drawer-footlinks{display:flex;justify-content:space-between;align-items:center;gap:var(--s-3);margin-top:var(--s-3);font-family:var(--font-mono);font-size:9px;letter-spacing:1.5px;text-transform:uppercase;color:var(--ti-muted)}
    .ti-drawer-footlinks a{color:var(--ti-text);text-decoration:underline;text-underline-offset:3px}
    .ti-drawer-footlinks a:hover{color:var(--ti-yellow)}
    .ti-drawer-empty{text-align:center;padding:var(--s-16) 0;display:flex;flex-direction:column;align-items:center;gap:var(--s-4)}
    .ti-drawer-empty p{color:var(--ti-secondary)}
    #ti-drawer-gift:not(:empty){margin-bottom:var(--s-2)}
    .ti-drawer-gift-toggle{display:flex;align-items:center;justify-content:space-between;gap:8px;width:100%;background:transparent;border:1px solid var(--ti-border);cursor:pointer;padding:8px 10px;font-family:var(--font-condensed);font-weight:800;font-size:13px;text-transform:uppercase;letter-spacing:1.5px;color:var(--ti-yellow);text-align:left}
    .ti-drawer-gift-toggle b{color:var(--ti-ok)}
    .ti-drawer-gift-toggle:hover{background:var(--ti-card)}
    .ti-drawer-gift-arrow{color:var(--ti-muted);flex-shrink:0}
    .ti-gift-ck-prompt{border:1px solid var(--ti-yellow);background:rgba(238,255,0,.06);padding:10px;margin-bottom:var(--s-2);font-family:var(--font-condensed);font-weight:800;font-size:14px;text-transform:uppercase;letter-spacing:1px;color:var(--ti-text)}
    .ti-gift-ck-actions{display:flex;gap:8px;margin-top:8px;flex-wrap:wrap}
    .ti-drawer-gift-cards{display:flex;flex-direction:column;gap:6px;margin-top:6px;max-height:min(38vh,260px);overflow-y:auto}
    .ti-drawer-gift-card{display:flex;align-items:center;gap:10px;border:1px solid var(--ti-border);padding:8px;background:var(--ti-card)}
    .ti-drawer-gift-card.is-selected{outline:2px solid var(--ti-yellow);outline-offset:-2px}
    .ti-drawer-gift-card img{width:44px;height:44px;object-fit:contain;background:var(--ti-black);padding:4px;flex-shrink:0}
    .ti-drawer-gift-card-body{flex:1;display:flex;flex-direction:column;gap:2px;overflow:hidden}
    .ti-drawer-gift-name{font-family:var(--font-condensed);font-weight:800;font-size:13px;text-transform:uppercase;color:var(--ti-text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
    .ti-drawer-gift-price{font-family:var(--font-mono);font-size:10px;letter-spacing:1px;color:var(--ti-muted)}
    .ti-drawer-gift-price b{color:var(--ti-ok)}
    .ti-gift-line-badge{font-family:var(--font-mono);font-size:10px;letter-spacing:1.5px;text-transform:uppercase;color:var(--ti-yellow)}
    .ti-gift-line-qty{font-family:var(--font-condensed);font-weight:700;font-size:14px;color:var(--ti-muted)}
    [data-ti-gift-error]{font-family:var(--font-mono);font-size:10px;letter-spacing:1px;text-transform:uppercase;color:var(--ti-err)}
    [data-ti-gift-error]:empty{display:none}
    [data-ti-gift-error]:not(:empty){margin-top:var(--s-2)}
    [data-ti-search-wrap]{position:relative}
    #ti-search-results{position:absolute;right:0;top:calc(100% + 8px);background:var(--ti-card);border:1px solid var(--ti-border);width:360px;max-height:480px;overflow-y:auto;z-index:200;box-shadow:var(--shadow-lg)}
    .ti-search-result{display:grid;grid-template-columns:48px 1fr auto;gap:var(--s-3);align-items:center;padding:var(--s-3) var(--s-4);text-decoration:none;border-bottom:1px solid var(--ti-border);transition:background var(--dur-fast)}
    .ti-search-result:hover{background:var(--ti-surface)}
    .ti-search-result img{width:48px;height:48px;object-fit:contain;background:var(--ti-black);padding:4px}
    .ti-search-result-img-placeholder{width:48px;height:48px;background:var(--ti-black)}
    .ti-search-result-body{display:flex;flex-direction:column;gap:2px;overflow:hidden}
    .ti-search-result-type{font-family:var(--font-mono);font-size:9px;letter-spacing:2px;text-transform:uppercase;color:var(--ti-yellow)}
    .ti-search-result-title{font-family:var(--font-condensed);font-weight:800;text-transform:uppercase;font-size:14px;color:var(--ti-text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
    .ti-search-result-price{font-family:var(--font-condensed);font-weight:800;font-size:15px;color:var(--ti-text);white-space:nowrap}
    .ti-search-all{display:block;padding:var(--s-3) var(--s-4);font-family:var(--font-condensed);font-weight:700;text-transform:uppercase;font-size:13px;letter-spacing:1.5px;color:var(--ti-yellow);text-decoration:none;text-align:center}
    .ti-search-all:hover{background:rgba(238,255,0,.06)}
    .ti-search-no-results{padding:var(--s-5) var(--s-4);font-family:var(--font-mono);font-size:11px;letter-spacing:2px;text-transform:uppercase;color:var(--ti-muted);text-align:center}
    @media (max-width:480px){
      .ti-drawer-head{padding:var(--s-4)}
      #ti-drawer-incentives .ti-goalbar{padding:var(--s-3) var(--s-4)}
      #ti-drawer-body{padding:var(--s-3) var(--s-4)}
      #ti-drawer-foot{padding:var(--s-3) var(--s-4) calc(var(--s-4) + env(safe-area-inset-bottom))}
      .ti-drawer-total{font-size:22px;padding:var(--s-2) 0}
      .ti-drawer-gift-cards{max-height:30vh}
    }
  `;
  document.head.appendChild(s);
})();
